module.exports = __webpack_public_path__ + "static/station-with-modules-mobile-ae5e523175c3196d16975b8578cc043d.jpg";